import React from 'react'
import Icon from 'components/MainApp/atoms/Icon/icon'
import styles from './MainApp.organisms.Tags.TagAssociationSummary.module.scss'
import i18n from 'i18n'

const TagAssociationSummary = ({ sku, tagsAssociatedBySKU, handleDelete }) => {
  const tags = tagsAssociatedBySKU
    .find((tag) => tag.sku === sku.sku)
    .tags.map((tag) => {
      return (
        <div className={styles["location-summary-container-child"]}>
          <div className={styles["location-summary-left"]}>
            <div className={styles["path"]}>{tag.epc}</div>
          </div>
          <div className={styles["location-summary-right"]}>
            {handleDelete && (
              <div onClick={() => handleDelete(tag)}>
                <Icon name="trash_can" width={20} height={20} fill={'#3C7AF5'} />
              </div>
            )}
          </div>
        </div>
      )
    })

  return (
    <div className={styles["location-summary-container"]}>
        <div className={styles["location-summary-left"]}>
          <div className={styles["items"]}>{i18n.t("product").concat(": ", i18n.t("sku")," ", sku.sku)}</div>
        </div>
        <div className={styles["location-summary-right"]}>
        {tags}
        </div>
    </div>
  )
}

export default TagAssociationSummary
